// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
sync(store, router)

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

import localforage from 'localforage'
import interactjs from 'interactjs'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
Vue.use(Croppa)
// import 'leaflet/dist/leaflet.css'
// import Vue2Leaflet from 'vue2-leaflet'
// Vue.use(Vue2Leaflet)
// import VueWorker from 'vue-worker'
// Vue.use(VueWorker)
Object.defineProperty(Vue.prototype, '$interact', { value: interactjs })
localforage.config({
  name: 'blhcertificationprocess'
})

Vue.config.productionTip = false
Vue.use(VueMaterial)
Vue.material.registerTheme({
  default: {
    primary: {
      color: 'amber',
      hue: 900
    },
    accent: 'indigo'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js